import { renderReactComponent } from "pf-provider-search";
import React from "react";
import { render } from "react-dom";
import registry from "dynamic-module-registry";
import ChatWidget from "../../shared_modules/five9-chat-widget";
const siteConfig = registry.get("siteConfig").siteConfig;
const chatFive9Context = registry.get("chatFive9Context");
document.addEventListener("DOMContentLoaded", function () {
  if (chatFive9Context?.isFiveChatEnabled) return;
  require("../../shared_modules/livechat");
});
function ProviderSearchContainer() {
  this.renderComponents();
}

const appId = document.getElementById("provider-search-container");
render(
  chatFive9Context?.isFiveChatEnabled && (
    <ChatWidget chatFive9Context={chatFive9Context} />
  ),
  document.getElementById("chat-five-9-container"),
);
ProviderSearchContainer.prototype.renderComponents = function () {
  const siteInfo = {
    redux: true,
    copyrightEndYear: new Date().getFullYear(),
  };

  renderReactComponent(appId, {
    siteInfo: { ...siteConfig, ...siteInfo },
  });
};

new ProviderSearchContainer();

require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/src/pages/provider-search/provider-search.scss');